export const getSettings = (state) => state.settings.get('settings').toJS();



// WEBPACK FOOTER //
// ./src/selectors/settings.js